import React from 'react'

import Box from 'components_new/atoms/Box'
import TableCell from 'components_new/atoms/Table/TableCell'
import Text from 'components_new/atoms/Text'

import TrendTag from 'components_new/molecules/TrendTag'

import { useTheme } from '@mui/material'

import { getCellScaleSx, getStickyCellSx } from '../utils'

interface FooterCellProps {
  align?: 'start' | 'end'
  increaseIsPositive?: boolean
  percentageDiff?: number | null
  scaleFactor: number
  showTrendTag?: boolean
  // set on a pinned column: how far from the edge it sits
  stickyLeft?: number
  value?: string | number | null
}

const FooterCell = (props: FooterCellProps) => {
  const {
    align = 'end',
    increaseIsPositive,
    percentageDiff,
    scaleFactor,
    showTrendTag,
    stickyLeft,
    value
  } = props

  const theme = useTheme()

  return (
    <TableCell
      sx={{
        borderRight: '1px solid',
        '&:last-child': { borderRight: 0 },
        borderRightColor: 'divider',
        whiteSpace: 'nowrap',
        width: '1%', // For auto sized, fit content cells. (Hacker).
        ...getCellScaleSx(scaleFactor),
        ...(stickyLeft !== undefined
          ? getStickyCellSx(theme, true, stickyLeft)
          : undefined)
      }}
      variant="footer"
    >
      {value ? (
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gridGap: 8,
            justifyContent: align === 'end' ? 'flex-end' : 'flex-start'
          }}
        >
          <Text
            color="text.primary"
            fontSize="inherit"
            fontWeight="bold"
            variant="body2"
          >
            {value}
          </Text>
          {showTrendTag &&
          increaseIsPositive !== undefined &&
          percentageDiff ? (
                <TrendTag
                  increaseIsPositive={increaseIsPositive}
                  value={percentageDiff}
                />
              ) : null}
        </Box>
      ) : null}
    </TableCell>
  )
}

export default FooterCell
